import * as adobe from '../utils/adobe';

export default function analyticsMiddleware(store) {
  return next => (action) => {
    const {
      type,
      payload,
      meta,
    } = action;

    next(action);

    if (payload && payload.then) {
      return;
    }

    const state = store.getState();

    switch (type) {
      case 'SEARCH_DOCUMENTS':
        adobe.trackUpdatedSearchResults({
          currentPage: parseInt(meta.page, 10),
          criteria: meta.query,
          total: payload.total,
          limit: payload.limit,
        });
        break;
      case 'SAVE_TO_LIBRARY':
        adobe.trackAddedReference({
          doc: meta.doc,
          stats: state.stats[meta.doc.id],
          position: meta.position,
          currentPage: meta.currentPage,
          isSuggested: meta.isSuggested,
        });
        break;
      case 'SHOW_DOCUMENT':
        adobe.trackSearchResultTitleClick({
          doc: payload.doc,
          stats: state.stats[payload.doc.id],
          criteria: meta.query,
          position: meta.position,
          currentPage: meta.currentPage,
          isSuggested: meta.isSuggested,
        });
        break;
      case 'SHOW_PDF':
        adobe.trackViewPdfClick({
          doc: state.documents[payload.id],
          stats: state.stats[payload.id],
        });
        break;
      case 'SHOW_FULL_TEXT':
        adobe.trackGetFullTextClick({
          doc: payload.doc,
          stats: state.stats[payload.doc.id],
          position: meta.position,
          currentPage: meta.currentPage,
          isSuggested: meta.isSuggested,
        });
        break;
      case 'SIGN_IN_TO_ADD_TO_LIBRARY':
        adobe.trackSignInToAddToLibrary({
          doc: state.documents[payload.id],
          stats: state.stats[payload.id],
        });
        break;
      case 'SIGN_IN_TO_VIEW_PDF':
        adobe.trackSignInToViewPdf({
          doc: state.documents[payload.id],
          stats: state.stats[payload.id],
        });
        break;
      case 'COPY_TO_CLIPBOARD':
        adobe.trackCopyToClipboard({
          doc: state.documents[payload.doc.id],
          stats: state.stats[payload.doc.id],
          citationStyle: payload.citationStyle,
        });
        break;
      case 'DOCUMENT_IN_VIEW':
        adobe.trackDocumentInView({
          doc: state.documents[payload.id],
          stats: state.stats[payload.id],
          isAuthenticated: state.session.isAuthenticated,
        });
        break;
      default:
        break;
    }
  };
}



// WEBPACK FOOTER //
// ./src/universal/ui/middleware/analytics.js